
import axios, { AxiosError } from 'axios';

const currentUrl = window.location.href;
const isLocal = currentUrl.indexOf("localhost")>=0;
const isQ = currentUrl.indexOf("qweb")>=0;
const host = isLocal ? import.meta.env.VITE_API_BASE_LOCAL || '' : isQ? import.meta.env.VITE_API_BASE_Q || '':import.meta.env.VITE_API_BASE || '';
export const http = axios.create({
    baseURL: `${host}/umbraco/aliudpharma`, 
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
});

http.interceptors.response.use(
    resp => {
        return resp;
    },
    (error: AxiosError) => {
        console.error(`[HTTP] ${error.config?.url}`, error);
        return Promise.reject(error);
    }
);